import { Permission } from '@/entities/permissions';
import PremiumAccessGate from '@/features/_shared/UpgradeToPremium/PremiumAccessGate';
import { usePermission } from '@/features/_shared/user';

const BlurBackdrop = () => {
  const { hasPermission } = usePermission();

  if (hasPermission(Permission.ViewIndexInformationChart)) {
    return null;
  }

  return (
    <PremiumAccessGate
      messageSx={{ fontWeight: 600, fontSize: '24px' }}
      variant='absolute'
    />
  );
};

export default BlurBackdrop;
